import styled, { css } from 'styled-components';
import { Icon as IconComponent } from 'src/components';
import _MissionCard from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/LearnImmerseCommunicate/Communicate/MissionCard';

export const Icon = styled(IconComponent)(
  ({ theme }) => css`
    position: absolute;
    bottom: -${theme.sz.s2};
    transform: rotate(-90deg);

    svg {
      width: ${theme.sz.s20};
      height: ${theme.sz.s20};
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    text-align: center;
    color: ${theme.co.primary99};
    font-family: ${theme.DEPRECATED_ty.boing};
    font-weight: ${theme.DEPRECATED_ty.bold};
    font-size: ${theme.sz.s10};
    line-height: 125%;
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    width: 60%;
    text-align: center;
    color: ${theme.co.primary99};
    font-size: ${theme.DEPRECATED_ty.large};
    line-height: 125%;
    margin-bottom: ${theme.sz.s12};
  `,
);

export const SubTitle = styled.div(
  ({ theme }) => css`
    text-align: center;
    color: ${theme.co.primary20};
    padding-top: ${theme.sz.s4};
    font-size: ${theme.DEPRECATED_ty.large};
    font-weight: ${theme.DEPRECATED_ty.bold};
  `,
);

export const CTA = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary20};
    margin-top: ${theme.sz.s8};
  `,
);

export const LeftSideContainer = styled.div(
  () => css`
    width: 60%;
  `,
);

export const RightSideContainer = styled.div(
  () => css`
    width: 35%;
  `,
);

export const LeftSideSubTitle = styled.div(
  ({ theme }) => css`
    position: relative;
    color: ${theme.co.primary20};
    padding-top: ${theme.sz.s4};
    font-size: ${theme.DEPRECATED_ty.large};
    font-weight: ${theme.DEPRECATED_ty.bold};
  `,
);

export const LeftSideTitle = styled.div(
  ({ theme }) => css`
    text-align: left;
    font-family: ${theme.DEPRECATED_ty.boing};
    color: ${theme.co.primary99};
    padding-top: ${theme.sz.s4};
    font-size: ${theme.sz.s8};
    font-weight: ${theme.DEPRECATED_ty.bold};
  `,
);

export const LeftSideDescription = styled.div(
  ({ theme }) => css`
    text-align: left;
    color: ${theme.co.primary99};
    padding-top: ${theme.sz.s4};
    font-size: ${theme.DEPRECATED_ty.medium};
  `,
);

export const LeftSideLearnables = styled.div(
  ({ theme }) => css`
    display: flex;
    margin-top: ${theme.sz.s8};

    > div {
      margin-right: ${theme.sz.s4};
    }
  `,
);

export const RightSideLearnables = styled.div(
  ({ theme }) => css`
    padding-top: ${theme.sz.s14};
    height: 474px;
    max-height: 474px;
    overflow: scroll;

    /* hides scrollbar for Firefox */
    scrollbar-width: none;
    /* hides scrollbar for rest browsers */
    &::-webkit-scrollbar {
      display: none;
    }
  `,
);

export const RightSideCTA = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary20};
    margin-top: ${theme.sz.s8};
  `,
);

export const TopContainer = styled.div(
  () => css`
    display: flex;
    justify-content: space-between;
    width: 100%;
  `,
);

export const BottomContainer = styled.div(
  ({ theme }) => css`
    padding-top: ${theme.sz.s10};
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  `,
);

export const AllRightReserved = styled.div(
  ({ theme }) => css`
    font-size: ${theme.DEPRECATED_ty.smaller};
    line-height: ${theme.DEPRECATED_ty.smaller};
    text-align: center;
    color: ${theme.co.secondary70};
    margin-top: ${theme.sz.s8};
  `,
);

export const MissionCard = styled(_MissionCard)(
  ({ theme }) => css`
    height: 348px;
    max-height: 348px;
    max-width: 593px;
    padding: ${theme.sz.s4};
    margin-top: ${theme.sz.s8};

    img {
      width: 100%;
      object-fit: cover;
    }
  `,
);
